import styled from "styled-components";
export const HistoriesStyled = styled.div`
  .history-wrapper {
    display: block;
    border: 1px solid #b59898;
    border-radius: 3px;
    padding: 0.5rem;
    margin-bottom: 10px;
    .action-made {
      padding: 0.5rem 0px;
      .d-flex {
      }
      img {
        height: 30px;
        border-radius: 50%;
      }
      p {
        font-size: 14px;
      }
    }
    .action-date {
      text-align: left;
      p {
        color: #6f5959;
      }
    }

    @media (max-width: 768px) {
      /* p {
        font-size: 12px !important;
      }
      img {
        height: 25px !important;
      } */
      img {
        height: 30px;
        border-radius: 50%;
        width: 10%;
      }
    }
  }
`;
